/* tslint:disable */

declare var Object: any;
export interface MechanicsInterface {
  "data": any;
  "id"?: any;
}

export class Mechanics implements MechanicsInterface {
  "data": any;
  "id": any;
  constructor(data?: MechanicsInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Mechanics`.
   */
  public static getModelName() {
    return "Mechanics";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Mechanics for dynamic purposes.
  **/
  public static factory(data: MechanicsInterface): Mechanics{
    return new Mechanics(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Mechanics',
      plural: 'Mechanics',
      path: 'Mechanics',
      idName: 'id',
      properties: {
        "data": {
          name: 'data',
          type: 'any'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
